import { INVOICE_WRITEOFF_RECORDS_TYPES } from '../data/invoice-writeoff.data';

export type InvoiceWriteoffNavigationDescriptionType<T> = {
  id: T;
  title: string;
  linkPrefix: string;
};

export type InvoiceWriteoffRecordType = typeof INVOICE_WRITEOFF_RECORDS_TYPES[number]['id'];
export type InvoiceWriteoffNavigationTypeRecord = Record<InvoiceWriteoffRecordType, InvoiceWriteoffNavigationDescriptionType<InvoiceWriteoffRecordType>>;
